/** @jsx jsx */
import { ReactNode } from 'react';

import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

import { displayFontStack } from '../shared';

const styles = css({
  margin: token('space.0', '0px'),
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  fontFamily: displayFontStack,
  fontSize: token('font.size.075', '12px'),
  fontWeight: token('font.weight.semibold', '600'),
  letterSpacing: '1px',
  textTransform: 'uppercase',
});

interface SmallCapsHeadingProps {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
  testId?: string;
  color?: string;
  children: ReactNode;
}

/**
 * __Small caps heading__
 *
 * A small caps heading renders a heading with `text-transform: 'uppercase';`
 *
 */
const SmallCapsHeading = ({
  as,
  color = token('color.text'),
  testId,
  children,
}: SmallCapsHeadingProps) => {
  const Markup = as;
  const colorStyles = css({ color });

  return (
    <Markup data-testid={testId} css={[styles, colorStyles]}>
      {children}
    </Markup>
  );
};

export default SmallCapsHeading;
